import React from 'react';

const AddForumModal = ({ show, onClose, descricaoForum, setDescricaoForum }) => {
  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="addForumModalLabel" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form method="post" action="/api/new/forum">
            <div className="modal-header">
              <h5 className="modal-title" id="addForumModalLabel">Cadastrar Novo Fórum</h5>
              <button type="button" className="close" onClick={onClose} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <label htmlFor="descricaoForum">Descrição</label>
              <input
                type="text"
                id="descricaoForum"
                className="form-control"
                name="descricao"
                value={descricaoForum}
                onChange={(e) => setDescricaoForum(e.target.value)}
                required
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Fechar</button>
              <button type="submit" className="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddForumModal;
